<template>
	<v-layout justify-end>
		<v-btn small flat icon @click="back" :disabled="from">
			<v-icon>chevron_left</v-icon>
		</v-btn>
		<v-btn small flat icon @click="forward" :disabled="to">
			<v-icon>chevron_right</v-icon>
		</v-btn>
	</v-layout>
</template>

<script>
import { mapState } from 'vuex';

export default {
	props: ['id'],
	methods: {
		back() {
			this.$router.back();
		},
		forward() {
			this.$router.forward();
		},
	},
	computed: {
		...mapState({
			pages: 'pages',
		}),
		pos() {
			return this.pages.findIndex(({ id }) => id === this.id);
		},
		from() {
			return this.pos === 0;
		},
		to() {
			return this.pos === this.pages.length - 1;
		},
	},
};
</script>
